export const LAST_UPDATED_CUSTOM_VALUE = 100;

export const LAST_UPDATED_VIEW_OPTIONS = [
  { value: 0, label: "All Time" },
  { value: 1, label: "1 day" },
  { value: 7, label: "7 days" },
  { value: 14, label: "14 days" },
  { value: 28, label: "28 days" },
  { value: LAST_UPDATED_CUSTOM_VALUE, label: "Custom" },
];

export const MANUAL_OPP_TYPES = {
  US_GOV_CON: "US_GOV_CON",
  SIMPLE: "SIMPLE",
  OCDS: "OCDS",
};

export const TYPE_SELECTOR_OPTIONS = [
  { value: MANUAL_OPP_TYPES.US_GOV_CON, label: "U.S. Government" },
  { value: MANUAL_OPP_TYPES.OCDS, label: "U.K. Government" },
  { value: MANUAL_OPP_TYPES.SIMPLE, label: "Other" },
];

export const SIMPLE_OPP_FIELDS = [
  "title",
  "description",
  "customer",
  "dueDate",
  "externalLink",
  "estimatedValue",
];

export const US_GOV_CON_OPP_FIELDS = [
  "title",
  "description",
  "customer",
  "subTier",
  "office",
  "externalId",
  "naicsCode",
  "popStreetAddress",
  "popCity",
  "popState",
  "popCountry",
  "popZip",
  "city",
  "state",
  "countryCode",
  "zipCode",
  "primaryContactFullname",
  "primaryContactEmail",
  "primaryContactPhone",
  "secondaryContactFullname",
  "secondaryContactEmail",
  "secondaryContactPhone",
  "pscCode",
  "setAside",
  "type",
  "status",
  "externalLink",
  "dueDate",
  "createdDate",
  "estimatedValue",
];

export const OCDS_OPP_FIELDS = [
  "title",
  "description",
  "externalLink",
  "externalId",
  "ocid",
  "noticeType",
  "procurementStage",
  "procedureType",
  "frameworkAgreement",
  "status",
  "publishedDate",
  "submissionDeadline",
  "enquiryDeadline",
  "estimatedValue",
  "cpvCode",
  "cpvDescription",
  "additionalCpvCodes",
  "buyerName",
  "buyerType",
  "buyerStreetAddress",
  "buyerLocality",
  "buyerPostalCode",
  "buyerRegion",
  "buyerCountry",
  "buyerWebsite",
  "contactName",
  "contactEmail",
  "contactTelephone",
  "deliveryRegion",
  "numberOfLots",
  "suitability",
];

export const SAM_GOV_TYPE = "SAM_GOV";
export const MANUAL_TYPE = "MANUAL";
export const EBUY_TYPE = "EBUY";
export const FIND_A_TENDER_TYPE = "FIND_A_TENDER";

export const OPPORTUNITY_SOURCES = {
  [SAM_GOV_TYPE]: "SAM.gov",
  [MANUAL_TYPE]: "Manual",
  [EBUY_TYPE]: "eBuy",
  [FIND_A_TENDER_TYPE]: "Find a Tender",
};

export const US_GOV_CON_TYPE = "US_GOV_CON";
export const OCDS_TYPE = "OCDS";
export const SIMPLE_TYPE = "SIMPLE";

export const OPPORTUNITY_TYPES = {
  [US_GOV_CON_TYPE]: "U.S. Government",
  [SIMPLE_TYPE]: "Other",
  [OCDS_TYPE]: "UK Government",
};

export const COLUMN_FALLBACK = "—";

export const DEFAULT_STAGE_COLOR = "#E5E7EB";
